
<template>
  <div
    v-if="message.selections.length > 0"
    class="d-flex justify-space-between align-center"
  >
    <!-- 卡片左右的換頁區域 -->
    <span
      class="d-flex align-center selections-change-page-area"
      @click="moveSelectionPage(message, -1)"
    >
      <v-btn icon dark x-large href="javascript:;">
        <v-icon>mdi-arrow-left-bold-circle-outline</v-icon>
      </v-btn>
    </span>
    <v-card
      dark
      class="selections-bg"
      style="min-width:220px; max-width:60vw; width: 100%; margin-bottom:10px; border:1px solid #AAA;"
      v-ripple
    >
      <v-carousel
        v-model="message._page"
        height="min-content"
        :show-arrows="false"
        hide-delimiters
      >
        <v-carousel-item
          v-for="(selection, j) in message.selections"
          :key="j"
          class="ma-3 mr-0"
          style="text-align:right;"
          @contextmenu="
            !$event.defaultPrevented &&
              showSelectionCardMenu(j, $event)
          "
        >
          <div class="selection-card-header">
            <long-touch
              @touchlong="showSelectionCardMenu(j, $event)"
            >
              <div class="text-center font-weight-bold">
                {{ j + 1 }}/{{ message.selections.length }}
              </div>
              <v-divider></v-divider>
            </long-touch>
          </div>
          <div class="selection-card-content">
            <div class="text-left font-weight-bold">例句:</div>
            <long-touch
              @touchlong="showSelectionItemMenu(j, -1, $event)"
            >
              <input
                v-model="selection.key"
                type="text"
                class="selections-item mb-3"
                @contextmenu.prevent.stop="
                  showSelectionItemMenu(
                    j,
                    -1,
                    $event
                  ) /*selectionMenu.show = true; window.console.log($event)*/
                "
                @keyup.enter="
                  selection.alias.push('')
                  $nextTick(() =>
                    $refs.selectionAlias[
                      $refs.selectionAlias.length - 1
                    ].focus()
                  )
                "
                placeholder="key *required"
              />
            </long-touch>
            <!-- <div class="text-left font-weight-bold">alias:</div> -->
            <div
              v-for="(alias, k) in selection.alias"
              :key="'sa-' + '-' + j + '-' + k"
            >
              <long-touch
                @touchlong="
                  showSelectionItemMenu(j, k, $event)
                "
              >
                <input
                  ref="selectionAlias"
                  v-model="selection.alias[k]"
                  type="text"
                  class="selections-item mb-3"
                  @contextmenu.prevent.stop="
                    showSelectionItemMenu(j, k, $event)
                  "
                  @keyup.enter="
                    selection.alias.push('')
                    if ($refs.selectionAlias) {
                      $nextTick(() =>
                        $refs.selectionAlias[
                          $refs.selectionAlias.length - 1
                        ].focus()
                      )
                    }
                  "
                  @keyup.delete="
                    selection.alias[k].length === 0 &&
                      selection.alias.splice(k, 1)
                  "
                  placeholder="alias"
                />
              </long-touch>
            </div>
              <!-- 選項底下的 (+) 按鈕 -->
            <div style="text-align:center; margin-bottom:50px;">
              <v-btn icon @click="selection.alias.push('')">
                <v-icon>mdi-plus-circle</v-icon>
              </v-btn>
            </div>
            <div style="text-align:center;">
              <template v-if="message.selectMode === 'ai' || message.selectMode === 'closest'">
                <div>Action:</div>
                <div>
                  <v-btn
                    block
                    @click="showSelectionActionMenu(i, j, $event)"
                    >{{ selection.action }}</v-btn
                  >
                </div>
                <div v-if="selection.action === 'to'">
                  <input
                    type="text"
                    class="mt-3"
                    placeholder="<scene id>/<message id>"
                    style="border-radius:10px; padding:5px; width:100%; background-color: rgb(120,120,120);"
                    v-model="selection.data.target"
                  />
                </div>
              </template>
              <template v-if="message.selectMode === 'advance'">
                <hr style="margin: 4px;"/>
                <div>
                  第二輪之後的例句
                </div>
                <template v-for="(subSelection, subIndex) in selection.data.subSelections">
                  <div class="selections-subselections" :key="subIndex">
                    <div>子分支-{{subIndex + 1}}</div>
                    <input
                      v-model="subSelection.key"
                      type="text"
                      class="selections-item mb-3"
                    />
                    <input
                      v-for="(alias, aIndex) in subSelection.alias"
                      :key="aIndex"
                      v-model="subSelection.alias[aIndex]"
                      type="text"
                      class="selections-item mb-3"
                    />
                    <div style="text-align:center;">
                      <v-btn icon @click="subSelection.alias.push('')">
                        <v-icon>mdi-plus-circle</v-icon>
                      </v-btn>
                    </div>
                    <div v-if="subSelection.action === 'to'">
                      TO:
                      <input
                        type="text"
                        class="mt-3"
                        placeholder="<scene id>/<message id>"
                        style="border-radius:10px; padding:5px; width: calc(100% - 4rem); background-color: rgb(120,120,120);"
                        v-model="subSelection.data.target"
                      />
                    </div>
                    <hr style="margin: 4px; margin-right: 16px; margin-left: 16px;"/>
                  </div>
                </template>
              </template>
            </div>
          </div>
        </v-carousel-item>
      </v-carousel>
    </v-card>
    <span
      class="d-flex align-center selections-change-page-area"
      @click="moveSelectionPage(message, 1)"
    >
      <v-btn icon dark x-large href="javascript:;">
        <v-icon>mdi-arrow-right-bold-circle-outline</v-icon>
      </v-btn>
    </span>
  </div>
</template>

<script>
import Message from '@/lib/Message'
import LongTouch from '@/components/LongTouch'

export default {
  components: {
    LongTouch
  },
  props: {
    msgIndex: {
      type: Number,
      required: true
    },
    message: {
      type: Message,
      required: true
    }
  },
  // model: {
  //   prpo: 'message',
  //   event: 'change'
  // },
  computed: {
    currentSelection(){
      let msg = this.message
      return msg.selections[msg._page]
    }
  },
  data(){
    return {
    }
  },
  mounted(){
    let msg = this.message
    if(!msg._page){
      msg._page = 0
    }
  },
  methods: {
    /**
     * 循環移動 "選項卡片" 的頁面
     * @param {Message} message
     * @param {Number} v 如果 v>0 代表往下v頁
     */
    moveSelectionPage(message, v) {
      let count = message.selections.length
      if(count > 0){
        let to = message._page + v
        for(; to < 0; to += count){
          // do nothing
        }
        for(; to >= count; to -= count){
          // do nothing
        }
        this.changeSelectionPage(message, to)
      }
    },
    /**
     * 切換 "選項卡片" 的頁面
     * @param {Message} message
     * @param {Number} page 目標頁面的索引值
     */
    changeSelectionPage(message, page){
      let count = message.selections.length
      let from = message._page
      if(page < 0){
        page = 0
      }
      if(page >= count){
        page = count - 1
      }
      if(from !== page){
        message._page = page
        this.$emit('change-page', {
          message,
          from,
          to: page
        })
      }
    },
    addNewAlias(){
      let selection = this.currentSelection
      let selectionAlias = this.$refs.selectionAlias
      selection.alias.push('')
      this.$nextTick(() => {
        selectionAlias[selectionAlias.length - 1].focus()
      })
    },
    showSelectionCardMenu(sIndex, event){
      this.$emit('show-menu', {
        type: 'card-menu',
        mIndex: this.msgIndex,
        sIndex,
        event
      })
    },
    showSelectionItemMenu(sIndex, aIndex, event){
      this.$emit('show-menu', {
        type: 'item-menu',
        mIndex: this.msgIndex,
        aIndex,
        sIndex,
        event
      })
    },
    showSelectionActionMenu(sIndex, event){
      this.$emit('show-menu', {
        type: 'action-menu',
        mIndex: this.msgIndex,
        sIndex,
        event
      })
    }
  }
}
</script>
<style scoped>
  .selections-bg input::placeholder {
    color: #aaa;
    font-size: 0.8rem;
  }
  .selections-bg {
    background-color: #ffad1f;
  }
  .selection-card-header{
    padding-right: 12px;
  }
  .selection-card-content{
    height:300px;
    overflow-y:scroll;
    padding-right: 12px;
  }
  .selections-change-page-area {
    height: 300px;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.2);
    opacity: 0.5;
  }
  .selections-item {
    border-radius: 10px;
    padding: 4px;
    padding-left: 8px;
    padding-right: 8px;
    width: 100%;
    background-color: rgb(120, 120, 120);
  }
  .selections-item {
    color: #fff;
    font-weight: bold;
  }
  .selection-card-wrapper{

  }
</style>
